/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

const DeltaArrayShape = PropTypes.arrayOf(
  PropTypes.oneOfType([
    PropTypes.shape({
      insert: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
      attributes: PropTypes.object,
    }),
    PropTypes.shape({
      retain: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
        .isRequired,
      attributes: PropTypes.object,
    }),
    PropTypes.shape({
      delete: PropTypes.number.isRequired,
    }),
  ]),
);

const DeltaShape = PropTypes.oneOfType([
  DeltaArrayShape,
  PropTypes.shape({
    ops: DeltaArrayShape,
  }),
]);

export default DeltaShape;
